const info = {
  ZH: { //中文翻译
    newMessage: '您有',
    newMessage1: '条新的消息',
    nomessage: '没有新消息',
    loginnamelost: '忘记用户名',
    email: '邮箱地址',
    send: '发送',
    cancel: '关闭',
    nullcheck: '不能为空',
    emailcheck: '格式不正确',
    sendSuccess: '发送成功',
    msgOne: '请输入您的电子邮箱地址并点击“发送”按钮, CAMDS中此电子邮箱地址所对应的用户名将发送给您.',
    msgTwo: '该邮箱未有效注册！',
    passwordlost: '忘记密码',
    name: '用户名',
    msgThree: '本账户已执行过该操作，请登录注册邮箱进行后续处理！',
    messageOne: '请输入您的用户名以及出于安全考虑与该用户名在CAMDS中相对应的 e-mail 地址. 在检查完您的输入之后, 新的密码将发送到该 e-mail 地址上.',
    Sending: '发送中.....',
    set: '设置',
    checkuserset: '请检查您的用户数据和其他设置',
    userinfo: '用户信息：',
    enname: '企业名称 :',
    authority: '访问权限 :',
    name1: '姓名 :',
    name2: '姓名',
    phonenumber: '电话号码 :',
    faxnumber: '传真号码 :',
    email1: '电子邮箱地址 :',
    eventemail: '为以下事件订阅 e-mail:',
    receive: '收到 MDS',
    receiverequest: '收到 MDS 请求',
    duetotrack: '跟踪到期',
    toreceive: '批准 MDS',
    requestdue: 'MDS 请求到期',
    toreject: '拒绝 MDS',
    torejectrequest: '拒绝 MDS 请求',
    deleterequest: '删除 MDS 请求',
    save: '保存',
    namec: '姓名不能为空',
    telephoneNo: '电话号码不能为空',
    emailc: 'Email格式不正确:例***@***.com',
    savesuccess: '数据保存成功！',
    management: '企业管理员',
    managementdata: '企业管理员数据',
    enterprise: '企业',
    department: '部门',
    batchRequest:"批量请求",
    startTime:"开始日期",
    endTime:"结束日期",
    singleRequest:"单一请求",
    saveTip:"您将要访问的链接不属于本网站，请注意风险!",
  },
  EN: { //英文翻译
    newMessage: 'You Have ',
    newMessage1: 'New Messages',
    nomessage: 'No Message',
    loginnamelost: 'user ID forgotten',
    email: 'E-mail',
    send: 'Send',
    cancel: 'Close',
    nullcheck: 'should not be blank',
    emailcheck: 'format incorrect',
    sendSuccess: 'The "Sending" is successful',
    msgOne: 'Please input your e-mail address and click on the "Send" Button, then the CAMDS user ID(s) referencing this e-mail address will be sent to you.',
    msgTwoInvalid: 'email address！',
    passwordlost: 'user ID forgotten',
    name: 'User Name',
    msgThree: 'The operation has been performed previously. Please login the registered mailbox to finish the operation.',
    messageOne: 'Please enter your user ID and for security reasons also the e-mail address associated with this user ID in CAMDS. After checking your input, the new password will be sent to this e-mail address.',
    Sending: 'Sending ...',
    set: 'Settings',
    checkuserset: 'Please check your user data and other settings:',
    userinfo: 'User Information',
    enname: 'Enterprise name :',
    authority: 'Access Permissions :',
    name1: 'Name :',
    name2: 'Name',
    phonenumber: 'Telephone No. :',
    faxnumber: 'Fax No. :',
    email1: 'E-mail :',
    eventemail: 'E-mail subscription offered for the following events:',
    receive: 'MDS Received',
    receiverequest: 'MDS Request Received',
    duetotrack: 'Follow-up due',
    toreceive: 'MDS Approved',
    requestdue: 'MDS Request due',
    toreject: 'MDS Rejected',
    torejectrequest: 'MDS Request rejected',
    deleterequest: 'MDS Request deleted',
    save: 'Save',
    namec: 'Name has to be specified!',
    telephoneNo: 'The telephone No. can not be blank',
    emailc: 'E-mail format error. For example, ***@***.com',
    savesuccess: 'Saved sucessfully!',
    management: 'Administrator',
    managementdata: 'Enterprise administrator information',
    enterprise: 'Enterprise',
    department: 'Department',
    batchRequest:"Batch request",
    startTime:"Start time",
    endTime:"End time",
    singleRequest:"Single request",
    saveTip:"The link you are about to access does not belong to this website, please be aware of the risks!",
  }
}
export default info //需要暴露出去
